import { useState } from 'react';
import type { PossibleRider, PossibleRiderAmendment } from '../types/lifecycle';

interface RiderFeedbackDialogProps {
  possibleRider: PossibleRider;
  amendment: PossibleRiderAmendment;
  onClose: () => void;
}

const reasons = [
  { value: 'neni_prilepek', label: 'Nejde o přílepek' },
  { value: 'je_prilepek', label: 'Je to přílepek' },
  { value: 'chybny_podklad', label: 'Chybný podklad' },
  { value: 'jiny_duvod', label: 'Jiný důvod' },
];

export function RiderFeedbackDialog({ possibleRider, amendment, onClose }: RiderFeedbackDialogProps) {
  const [reason, setReason] = useState(reasons[0].value);
  const [note, setNote] = useState('');
  const [status, setStatus] = useState<'idle' | 'sending' | 'sent' | 'failed'>('idle');

  async function submitFeedback() {
    setStatus('sending');
    try {
      // AGENTS exception: PR-D2 rider feedback, see docs/RIDER_FEEDBACK_OPERATIONS.md.
      const response = await fetch('/api/rider-feedback', {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({
          proposal_id: possibleRider.proposal_id,
          amendment_document_id: amendment.document_id,
          displayed_label: amendment.label || possibleRider.label,
          user_disagreement_reason: reason,
          user_note: note.trim() || undefined,
        }),
      });
      setStatus(response.ok ? 'sent' : 'failed');
    } catch {
      setStatus('failed');
    }
  }

  return (
    <div className="rider-dialog" role="dialog" aria-modal="true" aria-label="Zpětná vazba ke klasifikaci">
      <div className="rider-dialog__panel">
        <div className="rider-dialog__header">
          <h4>Nesouhlasím s klasifikací</h4>
          <button type="button" className="detail-panel__close" onClick={onClose} aria-label="Zavřít">×</button>
        </div>
        <fieldset>
          {reasons.map((item) => (
            <label key={item.value} className="rider-dialog__option">
              <input
                type="radio"
                name="rider-feedback-reason"
                value={item.value}
                checked={reason === item.value}
                onChange={() => setReason(item.value)}
              />
              <span>{item.label}</span>
            </label>
          ))}
        </fieldset>
        <textarea
          value={note}
          onChange={(event) => setNote(event.target.value)}
          rows={4}
          maxLength={1200}
          placeholder="Volitelná poznámka"
        />
        <div className="rider-dialog__actions">
          <button type="button" onClick={onClose}>Zrušit</button>
          <button type="button" onClick={submitFeedback} disabled={status === 'sending' || status === 'sent'}>
            {status === 'sending' ? 'Odesílám' : 'Odeslat'}
          </button>
        </div>
        {status === 'sent' && <p className="rider-dialog__status">Zpětná vazba byla odeslána.</p>}
        {status === 'failed' && <p className="rider-dialog__status rider-dialog__status--error">Odeslání se nepovedlo.</p>}
      </div>
    </div>
  );
}
